const STYLES = {
  "Commandé": "bg-slate-100 text-slate-700 border-slate-200",
  "Acheté": "bg-blue-50 text-blue-700 border-blue-200",
  "En transit": "bg-sky-50 text-sky-700 border-sky-200",
  "Arrivé au port": "bg-amber-50 text-amber-700 border-amber-200",
  "En dédouanement": "bg-orange-50 text-orange-700 border-orange-200",
  "Dédouané": "bg-teal-50 text-teal-700 border-teal-200",
  "Arrivé au parc": "bg-teal-50 text-teal-700 border-teal-200",
  "En préparation": "bg-violet-50 text-violet-700 border-violet-200",
  "Disponible": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "En entretien": "bg-rose-50 text-rose-700 border-rose-200",
  "Accidenté": "bg-red-100 text-red-800 border-red-300",
  "Hors service": "bg-slate-700 text-white border-slate-700",
  "En location": "bg-purple-50 text-purple-700 border-purple-200",
  "Loué": "bg-purple-50 text-purple-700 border-purple-200",
  "Réservé": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Vendu": "bg-slate-800 text-white border-slate-800",
  "Payée": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Partielle": "bg-amber-50 text-amber-700 border-amber-200",
  "Crédit": "bg-red-50 text-red-700 border-red-200",
  "À jour": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Échéance proche": "bg-amber-50 text-amber-700 border-amber-200",
  "En retard": "bg-red-50 text-red-700 border-red-200",
  "Très en retard": "bg-red-100 text-red-800 border-red-300",
  "Aujourd'hui": "bg-red-50 text-red-700 border-red-200",
  "À venir": "bg-slate-100 text-slate-600 border-slate-200",
  "Paiement partiel": "bg-amber-50 text-amber-700 border-amber-200",
  "Entièrement payé": "bg-slate-800 text-white border-slate-800",
  "Soldé": "bg-slate-800 text-white border-slate-800",
  "En cours": "bg-purple-50 text-purple-700 border-purple-200",
  "Prolongée": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Annulée": "bg-red-50 text-red-700 border-red-200",
  "Impayée": "bg-red-100 text-red-800 border-red-300",
  "Réservée": "bg-indigo-50 text-indigo-700 border-indigo-200",
  "Terminée": "bg-slate-100 text-slate-700 border-slate-200",
  "En attente": "bg-slate-100 text-slate-600 border-slate-200",
  "Active": "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Expirée": "bg-red-50 text-red-700 border-red-200",
  "Convertie en vente": "bg-cyan-50 text-cyan-700 border-cyan-200",
  "Brouillon": "bg-slate-100 text-slate-600 border-slate-200",
  "En attente": "bg-amber-50 text-amber-700 border-amber-200",
  "Approuvée": "bg-blue-50 text-blue-700 border-blue-200",
  "Refusée": "bg-red-100 text-red-800 border-red-300",
  "Partiellement payée": "bg-amber-50 text-amber-700 border-amber-200",
  "Annulée": "bg-slate-200 text-slate-500 border-slate-300 line-through",
};

export default function StatusBadge({ status }) {
  const cls = STYLES[status] || "bg-slate-100 text-slate-600 border-slate-200";
  return (
    <span className={`inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold ${cls}`} data-testid={`status-badge-${String(status).toLowerCase().replace(/[^a-zà-ÿ]/g, "-")}`}>
      {status || "—"}
    </span>
  );
}
